<template>
    <div class="leg-check">
        <span class="tag leg-tag" :class="{
            'is-danger': status === 'failed',
            'is-warning': status === 'warning',
            'is-primary': status === 'success'
        }" @mouseenter="setHovering(true)" @mouseleave="setHovering(false)">
            <font-awesome-icon :icon="['fas', icon]" />
        </span>
        <div class="box hover-panel" v-show="isHovering" @mouseenter="setHovering(true)"
            @mouseleave="setHovering(false)">
            <slot :is-hovering="isHovering"></slot>
        </div>
    </div>
</template>

<script>
import { ref, computed } from 'vue'

export default {
    name: 'LegCheck',
    props: {
        status: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const isHovering = ref(false)

        const icon = computed(() => {
            return props.status === 'failed' ? 'x' : props.status === 'warning' ? 'exclamation' : 'check'
        })

        const setHovering = (value) => {
            isHovering.value = value
        }

        return {
            isHovering,
            icon,
            setHovering
        }
    }
}
</script>

<style scoped>
.leg-check {
    position: relative;
}

.hover-panel {
    position: absolute;
    top: 100%;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
}
</style>